class EnaviOurCollections {
  constructor() {
    this.container = document.querySelector('.enavi-our-collections');
    if (!this.container) return;

    this.links = this.container.querySelectorAll('.enavi-our-collections__link');
    this.backgrounds = this.container.querySelectorAll('.enavi-our-collections__background-image');
    this.currentCollection = this.container.querySelector('.enavi-our-collections__current-collection');
    this.currentCollectionName = this.currentCollection.querySelector('.collection-name');

    this.init();
  }

  init() {
    this.links.forEach(link => {
      link.addEventListener('mouseenter', (e) => this.handleLinkHover(e));
    });
  }

  handleLinkHover(e) {
    const link = e.currentTarget;
    const imageUrl = link.dataset.image;
    
    // Update background images
    this.backgrounds.forEach(bg => {
      if (bg.style.backgroundImage.includes(imageUrl)) {
        bg.classList.add('active');
      } else {
        bg.classList.remove('active');
      }
    });

    // Update active link
    this.links.forEach(l => l.classList.remove('active'));
    link.classList.add('active');

    // Update current collection text
    this.currentCollectionName.textContent = `THE ${link.textContent.trim()} COLLECTION`;
    this.currentCollection.href = link.href;
  }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  new EnaviOurCollections();
});

// Re-initialize when Shopify section is reloaded
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.classList.contains('enavi-our-collections')) {
    new EnaviOurCollections();
  }
});